// Add or remove a class from the logo image and inner-wrap based on scroll position
window.addEventListener('scroll', () => {
    const logoImage = document.querySelector('.custom-logo-link img');
    const innerWrap = document.querySelector('.inner-wrap');

    if (logoImage) {
        if (window.scrollY > 50) {
            logoImage.classList.add('loschlegal-site-logo-small');
        } else {
            logoImage.classList.remove('loschlegal-site-logo-small');
        }
    }

    if (innerWrap) {
        if (window.scrollY > 50) {
            innerWrap.classList.add('scrolled');
        } else {
            innerWrap.classList.remove('scrolled');
        }
    }
});